// factory function, not to be confused with batws.js which is not (see module.fad.js)
import RestAPI from 'lib/rest';

var spec = {
  host: '/contentservices/v1',
  apis: {
    'dcr': {
      url: '/document/path/',
      calls: {
        fetch: {
          url: '{raw!path}?project={tda:WWW}',
          contentType: 'application/xml'
        }
      }
    }
  }
};

export default new RestAPI(spec);
